import { useHouseholdInsightsData } from '../../data/hooks/useHouseholdInsightsData.ts';
import { parseOccupationGroup } from '../../data/parsers/parseOccupationGroup.ts';
import { InsightsMetricList } from '../InsightsMetricList/InsightsMetricList.tsx';

export const OccupationGroup = () => {
  const { data, isLoading } = useHouseholdInsightsData(parseOccupationGroup);

  return <InsightsMetricList title="Occupation Group" unitLabel="households" items={data} isLoading={isLoading} />;
};
